import o from "./highrise1040.mjs";
function t() {
  return o;
}
const e = {
  self: t
};
export {
  e as default
};
